import React, { useState, useEffect, useRef } from 'react';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './HeritageCarouselModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import ModalOverlay from '../ModalOverlay';
import { StaticImage } from 'web-store-modules/packages/modal-media';
import { AppContext } from '../../../../AppContext';
import { CarouselArrowClicked, CarouselPopUpHotSpotClicked } from '../../../../utils/Analytics';
import { constructUrl } from '../../../../utils/UrlConstructor';

const isMobile = isMobileDevice();
const rightArrow = 'https://cdn.obsess-vr.com/vacheron/ARROW_Right.svg'
const leftArrow = 'https://cdn.obsess-vr.com/vacheron/ARROW_Legt.svg'
const closeIcon = 'https://cdn.obsess-vr.com/vacheron/vac_xicon_white.svg';

const swipeThreshold = 100;

const HeritageCarouselModal = ({ modalContent, onModalHidden, currentSceneName, hotspotId }) => {
    const { pages } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const modalRef = useRef();
    const [carouselWidth, setCarouselWidth] = useState();
    const [distOffset, setDistOffset] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [xTranslation, setXTranslation] = useState(0);
    const carouselContainer = useRef();
    const totalItems = pages.length;
    const [startPos, setStartPos] = useState(0);
    const [isUserMoving, setIsUserMoving] = useState(false);
    const [isUserInteracting, setIsUserInteracting] = useState(false);
    const [startTime, setStartTime] = useState(0);
    const [endPos, setEndPos] = useState(0);
    const [endTime, setEndTime] = useState(0);

    useEffect(() => {
        if (pages.length > 0) {
            const imageName = pages[0]?.image?.path.split('/').pop();
            CarouselPopUpHotSpotClicked(imageName);
        }
    }, []);

    useEffect(() => {
        fetchFontStyles();
        addListeners();
        return (() => {
            removeListeners();
        });
    }, []);

    useEffect(() => {
        if (carouselContainer.current && carouselContainer.current.clientWidth)
            setCarouselWidth(carouselContainer.current.clientWidth);
    }, [carouselContainer.current]);

    useEffect(() => {
        setDistOffset(carouselWidth * currentIndex);
    }, [currentIndex, carouselWidth])

    useEffect(() => {
        setXTranslation(distOffset ? -distOffset : 0);
    }, [distOffset])

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
    }
    const textItem = () => {
        const productImageStyle = { display: 'inline', minWidth: '100%', minHeight: '100%', objectFit: 'contain', transition: 'all 500ms', padding: '0', transform: `translate(${xTranslation}px, 0px)` };
        return pages.map((x, i) => {
            return (
                <div className='heritage-custom-text-modal-html-container' key={i} style={productImageStyle}>
                    <div style={{ fontSize: '24px', fontFamily: 'PreloCondensed Light', marginBottom: '15px' }}> {x.title} </div>
                    <div style={{ fontSize: '12px', fontFamily: 'Prelo Bold', marginBottom: '15px', color: '#767676', letterSpacing: '1px' }}> {x.subtitle} </div>
                    <div className="modal-description">
                        {(x.description && x.description != '') ? <p className="description">{x.description}</p> :
                            <img src={constructUrl(x.image)} className="image-carousel-container" style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
                        }
                    </div>
                </div>
            )
        })
    }

    const onclickHandler = (arrowType) => {
        if (arrowType == 'left-arrow') {
            setCurrentIndex(currentIndex - 1);
        } else {
            setCurrentIndex(currentIndex + 1);
        }
        //CarouselArrowClicked(currentSceneName);
    }

    const getSign = (num) => Math.sign(num);

    const withinBounds = (index, min, max) => (index < min || index + 1 > max) ? false : true;

    const onMouseDown = (e) => {
        e.preventDefault();
        setStartPos(e.clientX);
        setStartTime(Date.now())
        setIsUserMoving(true);
    }

    const onMouseMove = (e) => {
        e.preventDefault();
        if (isUserMoving && !isUserInteracting) {
            setEndPos(e.clientX);
            setEndTime(Date.now());
        }
    }

    const onMouseUp = (e) => {
        e.preventDefault();
        const dist = startPos - endPos;
        const isUserSwiping = Math.abs(startTime - endTime) < swipeThreshold ? true : false;
        if ((Math.abs(dist) > (carouselWidth * 0.4) || isUserSwiping) && endPos) {
            if (withinBounds(currentIndex + (getSign(dist) * 1), 0, totalItems)) {
                setCurrentIndex(currentIndex + (getSign(dist) * 1));
            }
        }

        setStartPos(0);
        setEndPos(0);
        setIsUserMoving(false);
    }

    const onTouchStart = (e) => {
        setStartPos(e.touches[0].pageX);
        setStartTime(Date.now())
        if (!carouselWidth) {
            setCarouselWidth((carouselContainer.current.clientWidth));
        }
    }

    const onTouchMove = (e) => {
        if (!isUserInteracting) {
            setEndPos(e.touches[0].pageX);
            setEndTime(Date.now());

            setIsUserMoving(true);
        }
    }

    const onTouchEnd = () => {
        const dist = startPos - endPos;
        const isUserSwiping = Math.abs(startTime - endTime) < swipeThreshold ? true : false;

        if ((Math.abs(dist) > (carouselWidth * 0.4) || isUserSwiping) && endPos) {
            if (withinBounds(currentIndex + (getSign(dist) * 1), 0, totalItems)) {
                setCurrentIndex(currentIndex + (getSign(dist) * 1));
            }
        }

        setStartPos(0);
        setEndPos(0);
        setIsUserMoving(false);
    }

    const textContainer = () => {
        return (
            <div className='text-modal-carousel'
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
                ref={carouselContainer} style={{ overflowY: currentIndex == 0 ? 'hidden' : 'auto' }}>
                {textItem()}
            </div>
        )
    }

    const arrowIndicatore = () => {
        return (
            <div className='text-modal-arrow'>
                {currentIndex > 0 && <div className="left-arrow" onClick={() => onclickHandler('left-arrow')}><img src={leftArrow} alt='left-arrow' /></div>}
                {totalItems > 1 && (currentIndex + 1) < totalItems && <div className="right-arrow image-carousel" onClick={() => onclickHandler('right-arrow')}><img src={rightArrow} alt='right-arrow' /></div>}
            </div>
        )
    }

    const renderModalContent = () => {
        return (
            <div className='text-modal-content' style={{ textAlign: 'center' }} ref={modalRef}>
                {arrowIndicatore()}
                {textContainer()}
            </div>
        )
    }

    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName="text-image-modal-container" onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded closeIconImage={closeIcon}>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <HeritageCarouselModal {...props} currentSceneName={appContextValue.currentSceneName} />
        )}
    </AppContext.Consumer>
);